// extracted by mini-css-extract-plugin
module.exports = {"jobList":"SectionJobList_jobList__trLCO","emptyJobListText":"SectionJobList_emptyJobListText__QrkXX"};